import { HeaderCategory } from "../../utils/headerTable/TabHeaderCategory";
import AgencyAction from "../action/AgencyAction";
import TableComponent from "../main/Table";
import TableComponentPaginationClient from "../main/TablePaginationClient";

export default function CategoryList({ listCategories, idAzienda }: { listCategories: any[], idAzienda: number }) {

    return (
        <>
            <div className="flex items-center justify-end">
                <AgencyAction type="addCategory" label="Aggiungi categoria" idAzienda={idAzienda} />
            </div>

            {listCategories && listCategories?.length > 0
                ? <TableComponentPaginationClient
                    columns={HeaderCategory}
                    data={listCategories}
                    type="userList"
                    isDisabledPagination={false}
                />
                : <p className="p-6 text-center">NESSUNA CATEGORIA PRESENTE</p>
            }
        </>
    )
}